import { Container } from '@/components'
import { Directory } from '@/components/integrations/directory'
import { IntegrationService } from '@/service'
import { unique } from '@/utils/helper'

interface IntegrationsCategoryPageProps {
  categories: string[]
  selected: {
    slug: string
    name: string
  }
  apps: AppModel[]
}

const IntegrationsCategoryPage = ({
  categories,
  selected,
  apps
}: IntegrationsCategoryPageProps): JSX.Element => (
  <Container
    headerBackground="#fff"
    url={`/integrations/category/${encodeURIComponent(selected.slug)}`}
    title={`${selected.name} | Integrations | HeyForm`}
  >
    <Directory
      key={selected.slug}
      categories={categories}
      selectedCategory={selected.name}
      groups={[{ category: selected.name, apps }]}
    />
  </Container>
)

export async function getServerSideProps({
  params
}: NextContext): Promise<unknown> {
  const slug = (params.category as string).toLowerCase()
  const result = await IntegrationService.list()

  const categories = unique(result.map(row => row.Category))
  const apps = result.filter(row => row.Category?.toLowerCase() === slug)

  const categoryName = categories.find(c => c.toLowerCase() === slug)
  if (!categoryName) return { notFound: true }

  return {
    props: {
      categories,
      selected: {
        slug,
        name: categoryName
      },
      apps
    }
  }
}

export default IntegrationsCategoryPage
